import React from "react";
import { InfoBanner, Spinner, TableHeader } from "@services/ui-components";
import { Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useReactiveVar } from "@apollo/client";
import CreateProductForm from "./CreateProductForm";
import { useParams } from "react-router-dom";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

const CreateProduct: React.FC = () => {
    const { t } = useTranslation();
    const { branchId } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);

    if (!currentCompanyId) return <Spinner />;

    return (
        <div className="mb-3">
            <InfoBanner>
                <p className="fs-7 mb-0">
                    <Trans
                        i18nKey="Required fields are marked with an asterisk -"
                        components={{ red: <span className="text-danger">*</span> }}
                    />
                </p>
            </InfoBanner>
            <TableHeader
                title={t("Add New Product")}
                paths={[
                    {
                        path: `/warehouse/${currentCompanyId}/new-product/branch/${branchId}`,
                        label: t("Warehouse accounting"),
                    },
                    { path: `/warehouse/product/${currentCompanyId}/branch/${branchId}`, label: t("Products") },
                    {
                        path: `/warehouse/${currentCompanyId}/new-product/branch/${branchId}`,
                        label: t("Add New Product"),
                    },
                ]}
                colSize={12}
            />
            <Row>
                <CreateProductForm />
            </Row>
        </div>
    );
};

export default CreateProduct;
